export default __webpack_public_path__ + "static/media/spot-logo-white.8cdfb865.svg";